const danteCleanUp = function () {
  return function (html) {
    html = html.replace('is-mediaFocused', '');
    html = html.replace(/<span class="defaultValue">.*<\/span>/, '');
    return html;
  };
};

export default danteCleanUp;
